import { render, staticRenderFns } from "./BasicHeading.vue?vue&type=template&id=107846de"
import script from "./BasicHeading.vue?vue&type=script&lang=js"
export * from "./BasicHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports